import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import jsPDF from "jspdf";
import "jspdf-autotable";

const GENERATE_PDF_STYLES = {
    modalContent: {
        borderRadius: "24px",
        overflow: "hidden",
        border: "1px solid rgba(226, 232, 240, 1)",
        boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)",
    },
    modalDialog: {
        maxWidth: "920px",
    },
    modalHeader: {
        padding: "18px 22px",
        borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
        background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)",
    },
    headerContent: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "14px",
    },
    modalFooter: {
        padding: "16px 22px 20px",
        borderTop: "1px solid rgba(226, 232, 240, 0.9)",
        background: "#ffffff"
    },
    titleWrap: {
        display: "flex",
        alignItems: "center",
        gap: "14px",
    },
    headerIcon: {
        width: "46px",
        height: "46px",
        borderRadius: "15px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
        color: "#4338ca",
        fontSize: "21px",
        boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)",
    },
    title: {
        fontSize: "22px",
        fontWeight: 800,
        color: "#0f172a",
        lineHeight: 1.1,
        margin: 0,
    },
    subtitle: {
        fontSize: "12px",
        color: "#64748b",
        marginTop: "4px",
    },
    closeButton: {
        width: "38px",
        height: "38px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#64748b",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "16px",
        fontWeight: 800,
        boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
        flexShrink: 0,
    },
    modalBody: {
        padding: "20px 22px 22px 22px",
        background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
    },
    helperCard: {
        borderRadius: "16px",
        padding: "16px",
        background: "linear-gradient(135deg, rgba(248,250,252,0.98) 0%, rgba(239,246,255,0.9) 100%)",
        border: "1px solid rgba(191, 219, 254, 0.9)",
        marginBottom: "16px",
    },
    helperTitle: {
        fontSize: "14px",
        fontWeight: 800,
        color: "#0f172a",
        marginBottom: "8px",
    },
    helperText: {
        fontSize: "12px",
        lineHeight: 1.7,
        color: "#64748b",
        margin: 0,
    },
    tableCard: {
        borderRadius: "20px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
        overflow: "hidden",
    },
    table: {
        margin: 0,
    },
    tableToolbar: {
        padding: "16px 18px",
        borderBottom: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
    },
    tableTitle: {
        fontSize: "15px",
        fontWeight: 800,
        color: "#0f172a",
        margin: 0,
    },
    tableSubtitle: {
        fontSize: "12px",
        color: "#64748b",
        marginTop: "4px",
    },
    tableHeader: {
        background: "#f8fbff",
        borderBottom: "1px solid #e2e8f0",
    },
    headerCell: {
        fontSize: "12px",
        fontWeight: 800,
        color: "#475569",
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        padding: "14px 20px",
    },
    rowCell: {
        fontSize: "13.5px",
        color: "#1e293b",
        padding: "16px 20px",
        verticalAlign: "middle",
    },
    checkboxCell: {
        width: "60px",
        textAlign: "center",
    },
    footerActions: {
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
    },
    cancelButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: "#ffffff",
        color: "#475569",
        padding: "10px 18px",
        fontSize: "12px",
        fontWeight: 800,
    },
    generateButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "999px",
        border: "none",
        background: "linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)",
        color: "#ffffff",
        padding: "10px 20px",
        fontSize: "12px",
        fontWeight: 800,
        boxShadow: "0 14px 28px rgba(79, 70, 229, 0.2)",
    },
};

const GeneratePdf = (props) => {

    const { handlepdfShowHide, pdfShowHide,
        selectedCol, selectedColData } = props;

    const [columns, setColumns] = useState([]);
    const [colData, setColData] = useState([]);

    useEffect(() => {
        if (!pdfShowHide) {
            setColumns([]);
            setColData([]);
        }
    }, [pdfShowHide])

    const handleChkChange = ({ currentTarget }) => {
        const id = currentTarget.name.split("_")[1];
        const col = [...columns];
        const colD = [...colData];

        if (currentTarget.checked) {
            const obj = selectedCol[0][id];
            col.push(obj);
            colD.push(id);
        } else {
            const index = colD.findIndex((x) => x === id);
            if (index > -1) {
                col.splice(index, 1);
                colD.splice(index, 1);
            }
        }
        setColumns(col);
        setColData(colD);
    };

    const handleSelectAll = ({ currentTarget }) => {
        if (currentTarget.checked && selectedCol.length > 0) {
            setColumns([...selectedCol[0]]);
            setColData(selectedCol[0].map((_, index) => index.toString()));
        } else {
            setColumns([]);
            setColData([]);
        }
    };

    const exportPDF = () => {
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "landscape"; // portrait or landscape
        //const marginLeft = 10;
        const doc = new jsPDF(orientation, unit, size);
        doc.setFontSize(15);
        const title = "";
        const headers = [columns];
        const data = [];
        selectedColData.map((item) => {
            let dt = [];
            colData.map((c) => dt.push(item[c]));
            data.push(dt);
        });
        let content = {
            startY: 50,
            head: headers,
            body: data,
        };
        //doc.text(title, marginLeft, 10);
        doc.autoTable(content);
        doc.save(`Report.pdf`);
    };

    return (
        <Modal
            show={pdfShowHide}
            size="xl"
            centered
            onHide={() => handlepdfShowHide("")}
            dialogClassName="generate-pdf-popup-modal-dialog"
            contentClassName="generate-pdf-popup-modal-content"
        >
            <style>
                {`
          .generate-pdf-popup-modal-dialog {
            max-width: ${GENERATE_PDF_STYLES.modalDialog.maxWidth};
          }
          .generate-pdf-popup-modal-content {
            border-radius: ${GENERATE_PDF_STYLES.modalContent.borderRadius};
            overflow: ${GENERATE_PDF_STYLES.modalContent.overflow};
            border: ${GENERATE_PDF_STYLES.modalContent.border};
            box-shadow: ${GENERATE_PDF_STYLES.modalContent.boxShadow};
          }
          .generate-pdf-table tbody tr:hover {
            background-color: #fbfdff;
          }
          .custom-pdf-checkbox {
            width: 18px;
            height: 18px;
            cursor: pointer;
            accent-color: #2563eb;
            border: 1.5px solid #cbd5e1;
            border-radius: 4px;
            vertical-align: middle;
          }
        `}
            </style>

            <Modal.Header style={GENERATE_PDF_STYLES.modalHeader}>
                <div style={GENERATE_PDF_STYLES.headerContent}>
                    <Modal.Title as="div" style={GENERATE_PDF_STYLES.titleWrap}>
                        <div style={GENERATE_PDF_STYLES.headerIcon}>
                            <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                        </div>
                        <div>
                            <div style={GENERATE_PDF_STYLES.title}>Generate PDF Report</div>
                            <div style={GENERATE_PDF_STYLES.subtitle}>
                                Select the columns you want to include in your exported document.
                            </div>
                        </div>
                    </Modal.Title>
                    <button
                        type="button"
                        style={GENERATE_PDF_STYLES.closeButton}
                        onClick={() => handlepdfShowHide("")}
                        aria-label="Close generate pdf popup"
                    >
                        <i className="fa fa-times" aria-hidden="true"></i>
                    </button>
                </div>
            </Modal.Header>

            <Modal.Body style={GENERATE_PDF_STYLES.modalBody}>
                <div style={GENERATE_PDF_STYLES.helperCard}>
                    <div style={GENERATE_PDF_STYLES.helperTitle}>Selection guidance</div>
                    <p style={GENERATE_PDF_STYLES.helperText}>
                        Choose the specific data fields you need for your report. The PDF will be generated in landscape orientation for optimal readability.
                    </p>
                </div>

                <div style={GENERATE_PDF_STYLES.tableCard}>
                    <div style={GENERATE_PDF_STYLES.tableToolbar}>
                        <div style={GENERATE_PDF_STYLES.tableTitle}>Available Columns</div>
                        <div style={GENERATE_PDF_STYLES.tableSubtitle}>
                            {columns.length} column{columns.length === 1 ? "" : "s"} selected
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="table align-items-center table-hover generate-pdf-table" style={GENERATE_PDF_STYLES.table}>
                            <thead style={GENERATE_PDF_STYLES.tableHeader}>
                                <tr>
                                    <th style={{ ...GENERATE_PDF_STYLES.headerCell, ...GENERATE_PDF_STYLES.checkboxCell }}>
                                        <input
                                            type="checkbox"
                                            className="custom-pdf-checkbox"
                                            onChange={handleSelectAll}
                                            checked={selectedCol.length > 0 && columns.length === selectedCol[0].length}
                                        />
                                    </th>
                                    <th style={GENERATE_PDF_STYLES.headerCell}>Column Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedCol.length > 0 &&
                                    selectedCol[0].map((c, key) => (
                                        <tr key={key}>
                                            <td style={{ ...GENERATE_PDF_STYLES.rowCell, ...GENERATE_PDF_STYLES.checkboxCell }}>
                                                <input
                                                    type="checkbox"
                                                    className="custom-pdf-checkbox"
                                                    name={`col_${key}`}
                                                    id={`col_${key}`}
                                                    checked={colData.includes(key.toString())}
                                                    onChange={handleChkChange}
                                                />
                                            </td>
                                            <td style={GENERATE_PDF_STYLES.rowCell}>
                                                <label htmlFor={`col_${key}`} style={{ cursor: "pointer", margin: 0, width: "100%" }}>
                                                    {c}
                                                </label>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer style={GENERATE_PDF_STYLES.modalFooter}>
                <div style={GENERATE_PDF_STYLES.footerActions}>
                    <button
                        type="button"
                        style={GENERATE_PDF_STYLES.cancelButton}
                        onClick={() => handlepdfShowHide("")}
                    >
                        <i className="fa fa-times" aria-hidden="true"></i>
                        Cancel
                    </button>
                    <button
                        type="button"
                        style={GENERATE_PDF_STYLES.generateButton}
                        onClick={exportPDF}
                        disabled={columns.length === 0}
                    >
                        <i className="fa fa-cog" aria-hidden="true"></i>
                        Generate PDF
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default GeneratePdf;
